var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    transform: "translate(0.759 0.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_327",
    "data-name": "Ellipse 327",
    transform: "translate(-0.759 -0.848)",
    fill: "rgba(0,0,0,0.5)",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_24857",
    "data-name": "Path 24857",
    d: "M6.807,3.923V2h9.614V3.923h4.807V5.846H19.306V20.268a.961.961,0,0,1-.961.961H4.884a.961.961,0,0,1-.961-.961V5.846H2V3.923ZM5.846,5.846v13.46H17.383V5.846ZM8.73,8.73h1.923v7.692H8.73Zm3.846,0H14.5v7.692H12.576Z",
    transform: "translate(11.607 11.518)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteGray);
export default __webpack_public_path__ + "static/media/delete-gray.9bf289c52131aff6a72b26ee11f099d4.svg";
export { ForwardRef as ReactComponent };